// Crea tu look — versión Shopify (sin backend propio).
// Los productos se leen en vivo desde la Storefront API con el mismo token
// público que ya usa theme-snippet/vestidor-cart-suggestions.liquid.
// Los looks guardados viven en localStorage del navegador (no hay servidor
// propio que los persista entre dispositivos).
(function () {
  "use strict";

  var root = document.getElementById("ctl-app");
  if (!root) return;

  var SHOP_DOMAIN = root.dataset.shopDomain;
  var STOREFRONT_TOKEN = root.dataset.storefrontToken;
  var API_VERSION = root.dataset.apiVersion || "2024-10";
  var LOOKS_STORAGE_KEY = "ctl_looks_v1";
  var PRODUCTS_CACHE_KEY = "ctl_products_cache_v8"; // v8: cada pieza guarda también all_variants (tallas agotadas incluidas) para el aviso de stock. v7: custom.genero es una lista — se guardan TODOS los valores (p.genders array)
  var BACK_IN_STOCK_URL = "https://shopify-back-in-stock-br2d.onrender.com/subscribe"; // mismo servicio que el modal "¿Te avisamos cuando vuelva?" de la PDP (ff-main-product.liquid)
  // localStorage (no sessionStorage): el catálogo no cambia cada hora, así
  // que se cachea 24h y sobrevive entre pestañas/recargas — "Actualizar
  // catálogo" fuerza un refresco inmediato cuando haga falta.
  var PRODUCTS_CACHE_TTL_MS = 24 * 60 * 60 * 1000;

  // ---------- mismos diccionarios que server/categoryGroup.js ----------
  var CATEGORY_GROUPS = {
    camisetas: { label: "Camisetas", slot: true, matches: ["camiseta algodon", "camiseta manga corta", "camiseta manga larga", "camiseta mc padel", "camiseta termal", "camiseta tirantes", "camiseta tt padel", "top", "polo"] },
    segunda_capa: { label: "Segunda capa", slot: true, matches: ["chaleco fibra", "chaleco polar", "chaleco soft shell", "polar fleece", "polar grid", "polar stretch", "sudadera casual", "sudadera tecnica", "look wool", "hibrido", "chaqueta", "chaqueta larga", "chaqueta ligera"] },
    chaquetas: { label: "Tercera capa", slot: true, matches: ["chaqueta soft shell", "chaqueta fibra", "chaqueta shell"] },
    pantalon_largo: { label: "Pantalón largo", slot: true, matches: ["pantalon", "pantalon casual", "pantalon co", "pantalon deporte", "pantalon desmontable", "pantalon fw", "pantalon impermeable", "pantalon ss", "pant largo deporte", "mallas"] },
    pantalon_corto: { label: "Pantalón corto", slot: true, matches: ["pantalon corto", "short deportivo", "short padel"] },
    falda: { label: "Falda", slot: true, matches: ["falda padel"] },
    vestido: { label: "Vestido", slot: true, matches: ["vestido padel"] },
    calcetines: { label: "Calcetines", slot: true, matches: ["calcetines"] },
    calzado: { label: "Calzado", slot: true, matches: ["botas", "sandalias", "zapato impermeable", "zapatos", "calzado padel", "casual", "deportiva", "multiactividad"] },
    complementos: { label: "Complementos", slot: true, matches: ["gorras", "gorros", "guantes", "mochila", "botella", "tubulares", "varios"] },
    padel: { label: "Pádel", slot: false, matches: ["pala padel", "paletero padel", "accesorios padel"] },
    trekking: { label: "Trekking", slot: false, matches: ["bastones"] }
  };
  var SLOT_ORDER = ["camisetas", "segunda_capa", "chaquetas", "pantalon_largo", "pantalon_corto", "falda", "vestido", "calzado", "calcetines", "complementos"];
  var CATEGORY_GROUP_LABELS = { otros: "Otros" };
  Object.keys(CATEGORY_GROUPS).forEach(function (k) { CATEGORY_GROUP_LABELS[k] = CATEGORY_GROUPS[k].label; });

  var CATEGORY_GROUP_REVERSE = {};
  Object.keys(CATEGORY_GROUPS).forEach(function (key) {
    CATEGORY_GROUPS[key].matches.forEach(function (raw) { CATEGORY_GROUP_REVERSE[raw] = key; });
  });
  // Algunos pantalones/mallas cortos comparten el mismo productType que los
  // largos (p. ej. "Pantalon deporte"), así que el catálogo los agrupa mal
  // en pantalon_largo. Si el título deja claro que son cortos, se
  // reclasifican a pantalon_corto mirando el nombre del artículo.
  var SHORT_TITLE_PATTERN = /\bcortos?\b|\bcortas?\b/i;
  function categoryGroupFor(rawCategory, title) {
    var key = String(rawCategory || "").trim().toLowerCase();
    var group = CATEGORY_GROUP_REVERSE[key] || "otros";
    if (group === "pantalon_largo" && SHORT_TITLE_PATTERN.test(String(title || ""))) return "pantalon_corto";
    return group;
  }

  // ---------- mismos diccionarios que server/colorFamily.js ----------
  var FAMILY_ORDER = ["amarillo", "azul", "beige", "blanco", "gris", "marron", "morado", "multicolor", "naranja", "negro", "rojo", "rosa", "verde"];
  var FAMILY_COLORS = {
    amarillo: "#eab308", azul: "#3b82f6", beige: "#d4d4d8", blanco: "#ffffff", gris: "#9ca3af",
    marron: "#78350f", morado: "#a855f7", multicolor: "conic-gradient(red, yellow, lime, aqua, blue, magenta, red)",
    naranja: "#f97316", negro: "#111827", rojo: "#ef4444", rosa: "#ec4899", verde: "#22c55e"
  };
  var COLOR_CONCEPTS = {
    amarillo: ["gold honey", "illuminating", "illuminating/fair aqua", "illuminating/navy blue", "light yellow", "light yellow/blue", "light yellow/fair aqua", "light yellow/illuminating", "spring", "spring/royal", "spring/spring", "yellow", "yellow fluor", "yellow fluor/black", "iluminating", "honey", "gold"],
    azul: ["blue", "blue river/bluemoon", "blue/orange", "celestial", "celestial/illuminating", "ceramic", "ceramic/atlantic", "ceramic/ceramic", "ceramic/ceramic/fucsia", "ceramic/dark purple", "ceramic/fucsia fluor", "coronet blue", "coronet blue/light blue", "fair aqua", "fair aqua/diva pink", "fair aqua/light yellow", "fair aqua/yellow", "grey blue/diva pink", "ink blue", "light blue", "light blue/blue", "light blue/coral fluor", "light blue/coronet blue", "light blue/navy blue", "mineral blue", "mineral blue/light blue", "sky blue", "turquoise", "turquoise/charcoal", "turquoise/smoke", "turquoise/turquoise", "atlantic", "atlantic/ceramic", "atlantic/lima", "atlantic/opal/lima", "blue indigo/diva pink", "bluemoon", "bluemoon/coral fluor", "bluemoon/dark blue", "bluemoon/silver", "dark aqua", "dark aqua/red", "dark blue", "grey blue/orange", "jeans", "light blue/ice/navy blue", "navy blue", "navy blue degraded", "navy blue/aqua", "navy blue/blue", "navy blue/celestial/illuminati", "navy blue/coral fluor", "navy blue/fair aqua", "navy blue/gold honey", "navy blue/honey", "navy blue/illuminating", "navy blue/light blue", "navy blue/light blue/coral", "navy blue/light blue/diva pink", "navy blue/rose", "navy/spring", "royal", "royal/coral fluor", "royal/royal", "royal/spring", "royal/white/srping", "navy", "aqua blue"],
    beige: ["alfalfa/hielo", "aluminio", "aluminium/tapioca", "aliminium", "beige", "beige/rose", "stone", "tapioca", "tapioca/brown", "toasted", "tostado", "tostado/alfalfa", "aluminum"],
    blanco: ["hielo/alfalfa", "white", "white/atlantic", "white/black", "white/blue", "white/diva pink", "white/fair aqua", "white/gold", "white/lilac", "white/menta", "white/multicolor", "white/multicolour", "white/navy blue", "white/purple", "white/silver", "white/smoke/black", "white/white", "white/yellow fluor"],
    gris: ["aluminio metal", "aluminum/tapioca", "charcoal", "charcoal/lotus", "charcoal/orange", "dark grey", "dark grey/black", "dark grey/orange", "grey", "grey lilac", "ice", "silver", "silver/black", "silver/diva pink", "smoke", "smoke/black", "smoke/black/red", "smoke/blue river", "smoke/ceramic", "smoke/diva pink", "smoke/lotus", "smoke/orange", "smoke/silver/lotus", "smoke/turquoise"],
    marron: ["almendra", "brown", "brown/dark brown", "chocolate", "natural", "natural/chocolate", "mocha"],
    morado: ["dark purple", "grey lilac/diva pink", "lavanda", "lilac", "lilac grey", "lilac/diva pink", "lilac/purple", "lilac/violet", "orquidea", "purple", "violet", "violet/diva pink", "violet/grey lilac", "violet/lilac", "wine"],
    multicolor: ["autumnal", "dark atlantic/fair aqua/diva pink", "logo", "multicolor", "multicolor 2", "multicolor 3", "pilar", "virgen"],
    naranja: ["apricot", "cheddar", "coral", "coral fluor", "coral fluor/navy blue", "coral/jade", "coral/wine", "light orange", "peach", "orange", "orange fluor", "melon"],
    negro: ["black", "black/black", "black/dark grey", "black/dark grey/orange", "black/dark grey/royal", "black/diva pink", "black/fucsia", "black/grey", "black/light green", "black/lilac", "black/orange", "black/red", "black/royal", "black/silver", "black/smoke", "black/white", "black/yellow fluor"],
    rojo: ["barberry", "barberry/diva pink", "beet red/diva pink", "cherry", "magenta", "mineral red", "mineral red/diva pink", "red", "red/black", "red/red", "red/smoke"],
    rosa: ["crystal pink", "crystal pink/rose", "diva pink", "diva pink/beet red", "diva pink/magenta", "diva pink/mineral red", "diva pink/smoke", "fucsia", "fucsia fluor", "fucsia fluor/yellow fluor", "fucsia/black", "fucsia/fucsia", "light rose", "lotus", "lotus/silver", "magenta/diva pink", "pink", "pink fluor", "pink/silver", "raspberry", "rose", "rose/dark rose", "rose/ice/brown", "rose/light rose", "watermelon", "bonbon"],
    verde: ["alfalfa", "alfalfa/lime", "atlantic degraded", "caki", "caki/dark caki", "dark atlantic", "dark atlantic/diva pink", "fair aqua/dark atlantic", "fair aqua/dark atlantic/diva pink", "fair aqua/fucsia", "green", "green/atlantic", "green/fucsia", "jade", "light caki", "light caki/peach", "light green", "light lime", "light matcha/matcha", "light menta", "light menta/mineral blue", "lima", "lima/atlantic", "lime", "lime/royal", "matcha", "menta", "menta/atlantic", "menta/light yellow", "menta/wasabi", "menta/yellow", "mineral blue/light menta", "oil", "opal", "opal/atlantic", "pino/naranja", "wasabi", "acid lime", "esmeralda"]
  };
  var COLOR_REVERSE = {};
  var COLOR_DOMINANT = {};
  Object.keys(COLOR_CONCEPTS).forEach(function (canonical) {
    COLOR_CONCEPTS[canonical].forEach(function (raw) {
      COLOR_REVERSE[raw] = canonical;
      if (raw.indexOf("/") === -1) COLOR_DOMINANT[raw] = canonical;
    });
  });
  function colorFamily(rawColor) {
    var key = String(rawColor || "").trim().toLowerCase();
    if (COLOR_REVERSE[key]) return COLOR_REVERSE[key];
    var dominant = key.split("/")[0].trim();
    if (COLOR_DOMINANT[dominant]) return COLOR_DOMINANT[dominant];
    return "multicolor";
  }

  var NEUTRAL_HUE = -20;
  var COLOR_HUE_KEYWORDS = [
    ["navy", 230], ["marino", 230], ["ink blue", 230], ["indigo", 250],
    ["turquoise", 175], ["turquesa", 175], ["aqua", 175], ["teal", 178],
    ["fucsia", 320], ["fuchsia", 320], ["pink", 335], ["rosa", 335], ["salmon", 350],
    ["diva", 335], ["rose", 340], ["magenta", 315], ["raspberry", 345], ["bonbon", 340], ["lotus", 330],
    ["red", 5], ["rojo", 5], ["wine", 355], ["burgundy", 350], ["maroon", 355], ["garnet", 350],
    ["watermelon", 350], ["cherry", 357], ["garnacha", 350], ["barberry", 355],
    ["orange", 30], ["naranja", 30], ["coral", 15], ["peach", 22], ["melocoton", 22], ["melocotón", 22],
    ["melon", 28], ["apricot", 30],
    ["yellow", 50], ["amarillo", 50], ["mustard", 45], ["mostaza", 45], ["gold", 45], ["dorado", 45], ["spring", 50],
    ["iluminating", 50], ["illuminating", 50],
    ["green", 130], ["verde", 130], ["olive", 75], ["oliva", 75], ["alfalfa", 85], ["forest", 145],
    ["bottle", 150], ["lima", 90], ["lime", 90], ["menta", 155], ["esmeralda", 150], ["matcha", 95],
    ["jade", 155], ["wasabi", 95], ["pino", 140], ["oil", 120],
    ["blue", 215], ["azul", 215], ["sky", 200], ["cobalt", 220], ["atlantic", 205], ["royal", 230],
    ["denim", 210], ["cielo", 200], ["celestial", 205], ["jeans", 215],
    ["purple", 280], ["violet", 280], ["morado", 280], ["lila", 270], ["lavender", 260], ["violeta", 280],
    ["orquidea", 300], ["lavanda", 260],
    ["brown", 30], ["marron", 30], ["marrón", 30], ["caki", 50], ["khaki", 50], ["camel", 35],
    ["beige", 42], ["tapioca", 42], ["natural", 42], ["sand", 42], ["arena", 42], ["chocolate", 22],
    ["coffee", 22], ["tierra", 30], ["wood", 28], ["mocha", 22], ["tostado", 28], ["toasted", 28], ["honey", 40],
    ["grey", NEUTRAL_HUE], ["gray", NEUTRAL_HUE], ["gris", NEUTRAL_HUE], ["smoke", NEUTRAL_HUE],
    ["aluminum", NEUTRAL_HUE], ["aluminio", NEUTRAL_HUE], ["ceramic", NEUTRAL_HUE], ["ice", NEUTRAL_HUE],
    ["silver", NEUTRAL_HUE], ["plata", NEUTRAL_HUE], ["cement", NEUTRAL_HUE], ["concrete", NEUTRAL_HUE],
    ["charcoal", NEUTRAL_HUE], ["opal", NEUTRAL_HUE], ["stone", NEUTRAL_HUE], ["hielo", NEUTRAL_HUE],
    ["black", NEUTRAL_HUE], ["negro", NEUTRAL_HUE], ["noir", NEUTRAL_HUE], ["onyx", NEUTRAL_HUE],
    ["white", NEUTRAL_HUE], ["blanco", NEUTRAL_HUE], ["ivory", NEUTRAL_HUE], ["cream", NEUTRAL_HUE],
    ["crudo", NEUTRAL_HUE], ["nieve", NEUTRAL_HUE], ["snow", NEUTRAL_HUE]
  ];
  function estimateHue(rawColor) {
    var dominant = String(rawColor || "").split("/")[0].trim().toLowerCase();
    for (var i = 0; i < COLOR_HUE_KEYWORDS.length; i++) {
      if (dominant.indexOf(COLOR_HUE_KEYWORDS[i][0]) !== -1) return COLOR_HUE_KEYWORDS[i][1];
    }
    return 180;
  }
  function colorFor(rawColor) {
    var hue = estimateHue(rawColor);
    if (hue === NEUTRAL_HUE) return "hsl(30, 6%, 42%)";
    return "hsl(" + hue + ", 45%, 48%)";
  }
  function familyStyle(family) {
    var value = FAMILY_COLORS[family] || FAMILY_COLORS.multicolor;
    return value.indexOf("conic-gradient") === 0 ? "background-image:" + value : "background:" + value;
  }
  function colorTokens(rawColor) {
    return String(rawColor || "").split("/").map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean);
  }
  // Un look solo sugiere piezas con el MISMO nombre de color (único, o el
  // primero/segundo de los dos separados por "/") — sin parejas de colores
  // distintos ni coincidencia por familia.
  function tokensToSet(tokens) {
    var set = {};
    tokens.forEach(function (t) { set[t] = true; });
    return set;
  }

  // Botón "Mostrar neutros": con él activo, además de las piezas del mismo
  // nombre de color también se sugieren artículos de colores neutros
  // (blanco, negro, beige) aunque no coincidan con ninguna pieza del look —
  // van después de las coincidencias exactas. Sin él, solo mismo nombre.
  // Solo colores de UN único nombre exacto (no "BLACK/RED", no la familia
  // entera): BLACK, WHITE y crema (CREAM/CREMA, según cómo venga en el catálogo).
  var NEUTRAL_COLORS = { "BLACK": true, "WHITE": true, "CREAM": true, "CREMA": true };
  var NEUTRALS_STORAGE_KEY = "ctl_neutrals_v1";
  var neutralsOn = false;
  try { neutralsOn = localStorage.getItem(NEUTRALS_STORAGE_KEY) === "1"; } catch (e) { /* localStorage no disponible */ }

  // Puntuación de sugerencia de color: nº de tonos que coinciden por nombre;
  // 0.5 si no coincide pero es neutro y el botón está activo; 0 = no sugerir.
  function colorSuggestScore(p, compatibleTokenSet) {
    var score = colorTokens(p.color).filter(function (t) { return compatibleTokenSet[t]; }).length;
    if (score === 0 && neutralsOn && NEUTRAL_COLORS[String(p.color || "").trim().toUpperCase()]) return 0.5;
    return score;
  }
  // custom.genero es una lista: un mismo artículo puede llevar varios
  // valores a la vez (p. ej. HOMBRE + MUJER + UNISEX en una prenda que
  // vale para todos). Se normalizan TODOS los valores reconocidos del
  // metafield, no solo el primero que coincida — quedarse con uno solo
  // hacía que, por ejemplo, un artículo "HOMBRE, MUJER, UNISEX" solo
  // contara como "mujer" (por el orden de comprobación) y desapareciera al
  // filtrar por "Look hombre" en la guía. Cada palabra se comprueba con
  // límite de palabra (\b) para que "female" no cuele como "male" al
  // buscar substring. Sin match reconocido, el array queda vacío — no
  // cuela como "unisex" (ver genderOk más abajo, que deja pasar los
  // artículos sin género reconocido en vez de ocultarlos).
  var GENDER_KEYWORDS = [
    [/\binfantil\b/, "infantil"], [/\bkids?\b/, "infantil"], [/\bchild\w*\b/, "infantil"],
    [/\bni[nñ]os?\b/, "infantil"], [/\bni[nñ]as?\b/, "infantil"],
    [/\bmujer(es)?\b/, "mujer"], [/\bwomen\b/, "mujer"], [/\bfemale\b/, "mujer"],
    [/\bhombres?\b/, "hombre"], [/\bmale\b/, "hombre"],
    [/\bunisex\b/, "unisex"]
  ];
  function parseGenders(raw) {
    var value = String(raw || "").trim();
    if (!value) return [];
    var tokens = null;
    if (value.charAt(0) === "[") {
      try {
        var arr = JSON.parse(value);
        if (Array.isArray(arr)) tokens = arr.map(function (v) { return String(v); });
      } catch (e) { /* no era JSON válido: se trata como texto plano */ }
    }
    if (!tokens) tokens = value.split(",");
    var found = {};
    tokens.forEach(function (token) {
      var lower = String(token).trim().toLowerCase();
      GENDER_KEYWORDS.forEach(function (pair) {
        if (pair[0].test(lower)) found[pair[1]] = true;
      });
    });
    return Object.keys(found);
  }
  function capitalize(str) { return str.charAt(0).toUpperCase() + str.slice(1); }

  function formatMoney(amount, currency) {
    try {
      return new Intl.NumberFormat("es-ES", { style: "currency", currency: currency || "EUR" }).format(amount || 0);
    } catch (e) {
      return (amount || 0).toFixed(2) + " " + (currency || "EUR");
    }
  }

  // Medición anónima (sin correo ni nombre del look, que es texto libre).
  // Cada evento va a window.dataLayer como "ctl_<nombre>" (GTM/GA4) y también
  // como CustomEvent "ctl:track" en document, por si otra herramienta (p. ej.
  // Connectif) quiere engancharse sin tocar este archivo.
  function track(name, params) {
    var payload = { event: "ctl_" + name };
    Object.keys(params || {}).forEach(function (k) { payload[k] = params[k]; });
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) { /* sin dataLayer: no pasa nada */ }
    try {
      document.dispatchEvent(new CustomEvent("ctl:track", { detail: { name: name, params: params || {} } }));
    } catch (e) { /* CustomEvent no disponible */ }
  }

  // ---------- estado ----------
  var currentView = "guia";
  var PRODUCTS = [];
  var savedLooks = [];
  var pendingDeleteId = null;
  var state = { lookItems: {} };
  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function setHas(obj, key) { return Object.prototype.hasOwnProperty.call(obj, key); }
  function setSize(obj) { return Object.keys(obj).length; }

  var $ = function (sel) { return document.querySelector(sel); };
  var boardList = $("#ctl-board-list");
  var boardClearBtn = $("#ctl-board-clear");
  var saveNameInput = $("#ctl-save-name");
  var saveBtn = $("#ctl-save-btn");
  var armarioGrid = $("#ctl-armario-grid");
  var tabs = document.querySelectorAll(".ctl-tab");
  var toast = $("#ctl-toast");
  var toastText = $("#ctl-toast-text");
  var guiaStepEl = $("#ctl-guia-step");

  function iconSvg(icon, extraAttrs) {
    return '<svg ' + (extraAttrs || "") + '><use href="#ctl-icon-' + icon + '"></use></svg>';
  }
  function escapeHtml(str) {
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  // ---------- Storefront API ----------
  function storefrontQuery(query, variables) {
    return fetch("https://" + SHOP_DOMAIN + "/api/" + API_VERSION + "/graphql.json", {
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (res) { return res.json(); }).then(function (payload) {
      if (payload.errors) console.warn("Crea tu look: error en Storefront API", payload.errors);
      return payload.data || {};
    });
  }

  var PRODUCTS_QUERY =
    "query CtlProducts($cursor: String) {" +
    "  products(first: 50, after: $cursor, sortKey: TITLE) {" +
    "    pageInfo { hasNextPage endCursor }" +
    "    edges { node {" +
    "      id title productType" +
    "      featuredImage { url }" +
    "      genero: metafield(namespace: \"custom\", key: \"genero\") { value }" +
    "      actividad: metafield(namespace: \"custom\", key: \"actividad-lista\") { value }" +
    "      variants(first: 100) {" +
    "        edges { node {" +
    "          id availableForSale" +
    "          price { amount currencyCode }" +
    "          image { url }" +
    "          selectedOptions { name value }" +
    "        } }" +
    "      }" +
    "    } }" +
    "  }" +
    "}";

  function numericId(gid) { return String(gid).split("/").pop(); }
  function findColorOption(selectedOptions) {
    var entry = (selectedOptions || []).filter(function (o) { return /^colou?r$/i.test(String(o.name || "").trim()); })[0];
    return entry ? entry.value : "Sin color";
  }
  function findSizeOption(selectedOptions) {
    var entry = (selectedOptions || []).filter(function (o) { return /talla|size/i.test(String(o.name || "").trim()); })[0];
    return entry ? entry.value : "Talla única";
  }

  // El metafield "actividad" puede ser de tipo lista (ej. '["Yoga","Gym"]')
  // o texto simple (ej. "Trekking" o "Trekking, Gym"); se admite cualquiera
  // de las dos formas y siempre se devuelve como array normalizado.
  function parseActivities(raw) {
    var value = String(raw || "").trim();
    if (!value) return [];
    if (value.charAt(0) === "[") {
      try {
        var arr = JSON.parse(value);
        if (Array.isArray(arr)) return arr.map(function (v) { return String(v).trim(); }).filter(Boolean);
      } catch (e) { /* no era JSON válido: se trata como texto plano */ }
    }
    return value.split(",").map(function (v) { return v.trim(); }).filter(Boolean);
  }

  var MAX_PAGES = 40; // tope de seguridad (~2000 productos)

  function fetchAllProducts() {
    var out = [];
    function step(cursor, pageCount) {
      if (pageCount >= MAX_PAGES) return Promise.resolve(out);
      return storefrontQuery(PRODUCTS_QUERY, { cursor: cursor }).then(function (data) {
        var page = data.products;
        if (!page) return out;
        page.edges.forEach(function (edge) {
          var product = edge.node;
          var productId = numericId(product.id);
          var category = (product.productType || "").trim() || "Sin categoría";
          var categoryGroupKey = categoryGroupFor(category, product.title);
          var genders = parseGenders(product.genero && product.genero.value);
          var activities = parseActivities(product.actividad && product.actividad.value);
          var fallbackImage = product.featuredImage ? product.featuredImage.url : null;

          // Se agrupan TODAS las variantes disponibles de cada color (no solo
          // la primera), porque el popup de "Añadir al carrito" necesita
          // ofrecer un selector con las tallas realmente en stock.
          var byColor = {};
          var allByColor = {};
          var order = [];
          product.variants.edges.forEach(function (vEdge) {
            var v = vEdge.node;
            var color = findColorOption(v.selectedOptions);
            // Todas las tallas del color (también las agotadas) en su orden
            // original, para el popup del carrito: ahí las agotadas salen
            // marcadas con el botón "Avísame cuando esté disponible".
            if (!allByColor[color]) allByColor[color] = [];
            allByColor[color].push({ id: numericId(v.id), size: findSizeOption(v.selectedOptions), available: !!v.availableForSale });
            if (!v.availableForSale) return;
            if (!byColor[color]) { byColor[color] = []; order.push(color); }
            byColor[color].push(v);
          });

          order.forEach(function (color) {
            var variants = byColor[color];
            var primary = variants[0];
            out.push({
              id: productId + "::" + color,
              product_id: productId,
              title: product.title,
              category: category,
              category_group: categoryGroupKey,
              color: color,
              color_family: colorFamily(color),
              genders: genders,
              activities: activities,
              variants: variants.map(function (v) {
                return { id: numericId(v.id), size: findSizeOption(v.selectedOptions) };
              }),
              all_variants: allByColor[color],
              price: primary.price ? parseFloat(primary.price.amount) || 0 : 0,
              currency: primary.price ? primary.price.currencyCode : "EUR",
              image_url: primary.image ? primary.image.url : fallbackImage
            });
          });
        });

        if (page.pageInfo.hasNextPage) return step(page.pageInfo.endCursor, pageCount + 1);
        return out;
      });
    }
    return step(null, 0);
  }

  function readProductsCache() {
    try {
      var raw = localStorage.getItem(PRODUCTS_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.products)) return null;
      if (Date.now() - parsed.savedAt > PRODUCTS_CACHE_TTL_MS) return null;
      return { products: parsed.products, savedAt: parsed.savedAt };
    } catch (e) { return null; }
  }
  function writeProductsCache(products) {
    try {
      localStorage.setItem(PRODUCTS_CACHE_KEY, JSON.stringify({ savedAt: Date.now(), products: products }));
    } catch (e) { /* almacenamiento lleno o bloqueado: no pasa nada, simplemente no cachea */ }
  }

  // Sin botón "Actualizar catálogo": se enseña al instante lo guardado y, si
  // tiene más de PRODUCTS_FRESH_MS, se vuelve a pedir en segundo plano y se
  // repinta con el dato nuevo (precios y tallas disponibles/agotadas al día).
  // El tope de 24h (PRODUCTS_CACHE_TTL_MS) solo aplica a lo que se guarda tan
  // viejo que ya ni se enseña: ahí se pide y se espera, como siempre.
  var PRODUCTS_FRESH_MS = 30 * 60 * 1000;
  var backgroundRefreshing = false;
  function refreshCatalogInBackground() {
    if (backgroundRefreshing) return;
    backgroundRefreshing = true;
    fetchAllProducts().then(function (products) {
      // Si la API falla devuelve lista vacía: no se pisa lo que ya hay.
      if (!products.length) return;
      PRODUCTS = products;
      writeProductsCache(products);
      renderAll();
    }).catch(function () { /* se queda el catálogo guardado */ })
      .finally(function () { backgroundRefreshing = false; });
  }

  function loadProducts(forceRefresh) {
    if (!forceRefresh) {
      var cached = readProductsCache();
      if (cached) {
        PRODUCTS = cached.products;
        if (Date.now() - cached.savedAt > PRODUCTS_FRESH_MS) refreshCatalogInBackground();
        return Promise.resolve(PRODUCTS);
      }
    }
    return fetchAllProducts().then(function (products) {
      PRODUCTS = products;
      writeProductsCache(products);
      return PRODUCTS;
    });
  }

  // El catálogo ya no se pide al cargar la página: el primer paso de la
  // guía (elegir género) no lo necesita (las imágenes son URLs fijas, ver
  // GUIA_GENDER_IMAGES), así que pedir ~2000 artículos por adelantado solo
  // alargaba la carga inicial sin motivo. Se pide la primera vez que hace
  // falta de verdad (al elegir género, o al entrar en "Mis
  // looks"), y como esta promesa se reutiliza mientras está en curso, un
  // segundo disparador (p. ej. cambiar de pestaña justo después) no lanza
  // una segunda petición en paralelo.
  var productsLoadPromise = null;
  function ensureProductsLoaded() {
    if (PRODUCTS.length > 0) return Promise.resolve(PRODUCTS);
    if (!productsLoadPromise) {
      productsLoadPromise = loadProducts(false)
        .then(function (products) {
          renderAll();
          return products;
        })
        .catch(function (err) {
          showToast("No se pudo cargar el catálogo: " + err.message);
          throw err;
        })
        .finally(function () { productsLoadPromise = null; });
    }
    return productsLoadPromise;
  }

  // ---------- looks guardados (localStorage) ----------
  function loadLooks() {
    try {
      var raw = localStorage.getItem(LOOKS_STORAGE_KEY);
      savedLooks = raw ? JSON.parse(raw) : [];
    } catch (e) {
      savedLooks = [];
    }
  }
  function persistLooks() {
    try { localStorage.setItem(LOOKS_STORAGE_KEY, JSON.stringify(savedLooks)); } catch (e) { /* localStorage no disponible */ }
  }
  function genId() {
    return "look_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 8);
  }

  // ---------- render ----------
  function productImage(p) {
    return p.image_url ? '<img src="' + escapeHtml(p.image_url) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : "";
  }

  // Tallas realmente en stock para esta card (p.variants ya viene filtrado a
  // availableForSale en fetchAllProducts()). Sin mostrar nada si el único
  // "talle" es el placeholder "Talla única" (producto sin variante de talla).
  function cardSizesLabel(p) {
    var sizes = [];
    (p.variants || []).forEach(function (v) {
      if (v.size && sizes.indexOf(v.size) === -1) sizes.push(v.size);
    });
    if (sizes.length === 0) return "";
    if (sizes.length === 1 && sizes[0] === "Talla única") return "";
    return sizes.join(" · ");
  }

  function buildCardButton(p) {
    var added = setHas(state.lookItems, p.id);
    var card = document.createElement("button");
    card.className = "ctl-card";
    card.setAttribute("aria-pressed", added);
    card.dataset.id = p.id;
    var sizesLabel = cardSizesLabel(p);
    card.innerHTML =
      '<span class="ctl-card-icon">' + productImage(p) + '</span>' +
      '<span class="ctl-card-name">' + escapeHtml(p.title) + '</span>' +
      '<span class="ctl-card-tags">' +
        '<span class="ctl-card-category">' + escapeHtml(p.category) + '</span>' +
        '<span class="ctl-card-color">' + escapeHtml(p.color) + '</span>' +
        (sizesLabel ? '<span class="ctl-card-sizes">' + escapeHtml(sizesLabel) + '</span>' : '') +
      '</span>' +
      '<span class="ctl-card-price">' + formatMoney(p.price, p.currency) + '</span>';
    return card;
  }

  function renderBoard() {
    var items = PRODUCTS.filter(function (p) { return setHas(state.lookItems, p.id); });
    if (boardClearBtn) boardClearBtn.classList.toggle("ctl-visible", items.length > 0);
    boardList.innerHTML = "";
    if (items.length === 0) {
      boardList.innerHTML = '<div class="ctl-board-empty">Añade piezas desde la mesa para empezar a montar tu look.</div>';
    } else {
      items.forEach(function (p) {
        var row = document.createElement("div");
        row.className = "ctl-board-item";
        row.innerHTML =
          '<span class="ctl-board-item-icon">' + productImage(p) + '</span>' +
          '<span class="ctl-board-item-info">' +
            '<span class="ctl-board-item-name">' + escapeHtml(p.title) + '</span>' +
            '<span class="ctl-board-item-price">' + formatMoney(p.price, p.currency) + '</span>' +
          '</span>' +
          '<button class="ctl-board-item-remove" data-id="' + escapeHtml(p.id) + '" aria-label="Quitar ' + escapeHtml(p.title) + '">&times;</button>';
        boardList.appendChild(row);
      });
    }
    // El botón vive dentro de la propia lista, pegado al último artículo —
    // se recrea en cada render, por eso el listener de abrir el modal está
    // delegado en boardList (más abajo) en vez de colgado de este botón.
    var addBtn = document.createElement("button");
    addBtn.type = "button";
    addBtn.className = "ctl-add-piece-btn";
    addBtn.id = "ctl-open-add-modal";
    addBtn.textContent = "+ Sugerencias para tu look";
    boardList.appendChild(addBtn);

    $("#ctl-board-count").textContent = items.length + " " + (items.length === 1 ? "pieza" : "piezas");
    var total = items.reduce(function (sum, p) { return sum + (p.price || 0); }, 0);
    $("#ctl-board-total").textContent = formatMoney(total, items.length ? items[0].currency : "EUR");
  }

  function suggestionSections() {
    var lookProducts = PRODUCTS.filter(function (p) { return setHas(state.lookItems, p.id); });
    if (lookProducts.length === 0) return [];

    var usedGroups = {};
    lookProducts.forEach(function (p) { usedGroups[p.category_group] = true; });
    var tokenSet = {};
    lookProducts.forEach(function (p) { colorTokens(p.color).forEach(function (t) { tokenSet[t] = true; }); });
    var compatibleTokenSet = tokensToSet(Object.keys(tokenSet));

    var lookGenders = {};
    lookProducts.forEach(function (p) { p.genders.forEach(function (g) { lookGenders[g] = true; }); });
    var allowedGenders = null;
    if (lookGenders.hombre && !lookGenders.mujer) allowedGenders = { hombre: true, unisex: true };
    else if (lookGenders.mujer && !lookGenders.hombre) allowedGenders = { mujer: true, unisex: true };

    return SLOT_ORDER.filter(function (slot) { return !usedGroups[slot]; }).map(function (slot) {
      var items = PRODUCTS
        .filter(function (p) { return p.category_group === slot && !setHas(state.lookItems, p.id); })
        .filter(function (p) { return !allowedGenders || p.genders.length === 0 || p.genders.some(function (g) { return allowedGenders[g]; }); })
        .map(function (p) { return { p: p, score: colorSuggestScore(p, compatibleTokenSet) }; })
        .filter(function (entry) { return entry.score > 0; })
        .sort(function (a, b) { return b.score - a.score; })
        .slice(0, 10)
        .map(function (entry) { return entry.p; });
      return { key: slot, label: CATEGORY_GROUP_LABELS[slot], items: items };
    }).filter(function (section) { return section.items.length > 0; });
  }

  function refreshAfterLookChange() {
    renderBoard();
    updateSaveState();
    if (addModal.classList.contains("ctl-open")) renderAddModalGrid();
    if (!$("#ctl-view-guia").classList.contains("ctl-is-hidden")) renderGuia();
  }

  function toggleLookItem(id) {
    if (setHas(state.lookItems, id)) delete state.lookItems[id];
    else state.lookItems[id] = true;
    // Se resetean los filtros de color/actividad Y la búsqueda de la guía
    // en cada cambio: al añadir/quitar una pieza cambia qué colores
    // combinan, y un filtro o texto de búsqueda que se quedó puesto de
    // antes puede tapar sin darse cuenta las opciones que sí combinan con
    // lo recién elegido (parece que "no hay nada que pegue" cuando en
    // realidad sí hay, solo que el buscador tenía texto de otra búsqueda).
    guiaFilters = { colors: {}, activities: {} };
    guiaQuery = "";
    if (guiaSearchInput) guiaSearchInput.value = "";
    refreshAfterLookChange();
  }

  // ---------- Guía de looks (asistente paso a paso) ----------
  // Estado local del asistente (género elegido, filtros y búsqueda).
  // state.lookItems es "Tu look", el look que se está montando
  // que se está montando en cualquiera de las dos pestañas.
  var guiaSelectedGender = null;
  var guiaFilters = { colors: {}, activities: {} };
  var guiaQuery = "";
  var guiaRailScrollEl = $("#ctl-guia-rail-scroll");
  var guiaSearchRow = $("#ctl-guia-search-row");
  var guiaSearchInput = $("#ctl-guia-search");
  var guiaSectionsEl = $("#ctl-guia-sections");

  // Plegado de las secciones Color/Actividad del rail de la guía: el rail se
  // reconstruye entero en cada render, así que el estado vive aquí.
  var guiaColorExpanded = true;
  var guiaActivityExpanded = true;
  (function initGuiaFilterExpansion() {
    try {
      var storedColor = localStorage.getItem("ctl_guia_color_filter_expanded_v1");
      if (storedColor !== null) guiaColorExpanded = storedColor === "1";
      var storedActivity = localStorage.getItem("ctl_guia_activity_filter_expanded_v1");
      if (storedActivity !== null) guiaActivityExpanded = storedActivity === "1";
    } catch (e) { /* localStorage no disponible */ }
  })();

  function guiaLookProducts() {
    return PRODUCTS.filter(function (p) { return setHas(state.lookItems, p.id); });
  }

  function remainingGuiaSlots() {
    var used = {};
    guiaLookProducts().forEach(function (p) { used[p.category_group] = true; });
    return SLOT_ORDER.filter(function (slot) { return !used[slot]; });
  }

  // Mismo criterio de compatibilidad de color que suggestionSections().
  function guiaCompatibleTokens() {
    var tokenSet = {};
    guiaLookProducts().forEach(function (p) { colorTokens(p.color).forEach(function (t) { tokenSet[t] = true; }); });
    return tokensToSet(Object.keys(tokenSet));
  }

  function guiaAllowedGenders() {
    var genders = {};
    guiaLookProducts().forEach(function (p) { p.genders.forEach(function (g) { genders[g] = true; }); });
    // Infantil es una categoría aparte, no se mezcla con adulto/unisex.
    if (genders.infantil) return { infantil: true };
    if (genders.hombre && !genders.mujer) return { hombre: true, unisex: true };
    if (genders.mujer && !genders.hombre) return { mujer: true, unisex: true };
    return null;
  }

  // El género elegido en el primer paso ("Look hombre/mujer/unisex/infantil")
  // se combina con el que ya se deduce de las piezas elegidas
  // (guiaAllowedGenders). Cada opción filtra a lo suyo + unisex, salvo
  // "unisex" e "infantil" que filtran solo a lo suyo (si no, elegir
  // "unisex" mostraría también piezas de hombre y de mujer, que es justo lo
  // que no se quiere, e "infantil" es una categoría aparte).
  function guiaExplicitGenderFilter() {
    if (guiaSelectedGender === "hombre") return { hombre: true, unisex: true };
    if (guiaSelectedGender === "mujer") return { mujer: true, unisex: true };
    if (guiaSelectedGender === "unisex") return { unisex: true };
    if (guiaSelectedGender === "infantil") return { infantil: true };
    return null;
  }

  function guiaEffectiveAllowedGenders() {
    var fromChoice = guiaExplicitGenderFilter();
    var fromLook = guiaAllowedGenders();
    if (!fromChoice) return fromLook;
    if (!fromLook) return fromChoice;
    var combined = {};
    Object.keys(fromChoice).forEach(function (g) { if (fromLook[g]) combined[g] = true; });
    return combined;
  }

  // Imagen de fondo de cada card de género: URLs fijas (no dependen del
  // catálogo ni cambian solas al actualizarlo).
  var GUIA_GENDER_IMAGES = {
    hombre: "https://cdn.shopify.com/s/files/1/0834/1579/3985/files/Nueva_Coleccion_Hombre_bb7db9f5-abc4-48db-83d6-81903f569738.webp?v=1788511512",
    mujer: "https://cdn.shopify.com/s/files/1/0834/1579/3985/files/Nueva_Coleccion_Mujer_cbd665d0-42f9-4723-906c-7ebf26b8ad85.webp?v=1788512520",
    unisex: "https://cdn.shopify.com/s/files/1/0834/1579/3985/files/instagram-image-056a187a-3017-47ce-b6f7-33b7d6cbaa0b.jpg?v=1788732377",
    infantil: "https://www.izas-outdoor.com/cdn/shop/files/Alyssa-y-Elissa-490.jpg?v=1761208086&width=1920"
  };
  function guiaGenderImage(gender) {
    return GUIA_GENDER_IMAGES[gender] || null;
  }

  // El primer paso (elegir género) no necesita el catálogo — las 4 fotos de
  // fondo son URLs fijas (GUIA_GENDER_IMAGES) — así que se muestra al
  // instante sin esperar a la Storefront API. El catálogo solo se pide en
  // cuanto hace falta de verdad: al elegir género (ver más abajo) o al
  // entrar en "Mis looks".
  function renderGuia() {
    if (!guiaStepEl) return;
    if (!guiaSelectedGender) {
      if (guiaRailScrollEl) guiaRailScrollEl.innerHTML = "";
      if (guiaFilterToggleBtn) guiaFilterToggleBtn.classList.add("ctl-hidden");
      if (guiaSearchRow) guiaSearchRow.classList.add("ctl-hidden");
      if (guiaSectionsEl) guiaSectionsEl.innerHTML = "";
      renderGuiaGenderPicker();
      return;
    }
    if (PRODUCTS.length === 0) {
      guiaStepEl.innerHTML = '<div class="ctl-grid-empty">Cargando catálogo…</div>';
      if (guiaRailScrollEl) guiaRailScrollEl.innerHTML = "";
      if (guiaFilterToggleBtn) guiaFilterToggleBtn.classList.add("ctl-hidden");
      if (guiaSearchRow) guiaSearchRow.classList.add("ctl-hidden");
      if (guiaSectionsEl) guiaSectionsEl.innerHTML = "";
      ensureProductsLoaded();
      return;
    }
    if (guiaFilterToggleBtn) guiaFilterToggleBtn.classList.remove("ctl-hidden");
    if (guiaSearchRow) guiaSearchRow.classList.remove("ctl-hidden");
    renderGuiaAllCategories();
  }

  function renderGuiaGenderPicker() {
    var genders = [
      { key: "hombre", label: "Look hombre" },
      { key: "mujer", label: "Look mujer" },
      { key: "unisex", label: "Look unisex" },
      { key: "infantil", label: "Look infantil" }
    ];

    var html =
      '<div class="ctl-guia-intro">' +
        '<div class="ctl-eyebrow">Guía de looks</div>' +
        '<h2 class="ctl-guia-question">¿Por dónde empezamos?</h2>' +
        '<p class="ctl-guia-subtitle">Elige para quién es el look.</p>' +
      '</div>' +
      '<div class="ctl-guia-gender-grid">';

    genders.forEach(function (g) {
      html +=
        '<button type="button" class="ctl-guia-gender-card" data-gender="' + g.key + '">' +
          '<span class="ctl-guia-gender-label">' + g.label + '</span>' +
        '</button>';
    });

    html += '</div>';
    guiaStepEl.innerHTML = html;

    // El fondo se asigna aparte (no en el HTML) para no tener que escapar la
    // URL manualmente dentro de un atributo style.
    genders.forEach(function (g) {
      var img = guiaGenderImage(g.key);
      if (!img) return;
      var card = guiaStepEl.querySelector('.ctl-guia-gender-card[data-gender="' + g.key + '"]');
      if (card) card.style.backgroundImage = "url(" + JSON.stringify(img) + ")";
    });
  }

  // Todas las categorías pendientes se muestran a la vez, cada una en su
  // propia fila-carrusel (scroll horizontal, .ctl-guia-section-row). En
  // cuanto se elige una pieza, su categoría desaparece (remainingGuiaSlots)
  // y el resto se recalcula con el nuevo color de referencia. El rail
  // (Color/Actividad) y el buscador filtran sobre TODAS las secciones a la
  // vez; no hay filtro de categoría porque las categorías ya se ven todas.
  function renderGuiaAllCategories() {
    var hasItems = setSize(state.lookItems) > 0;
    var compatibleTokens = guiaCompatibleTokens();
    var allowedGenders = guiaEffectiveAllowedGenders();
    var remainingSet = {};
    remainingGuiaSlots().forEach(function (slot) { remainingSet[slot] = true; });

    // Piezas candidatas de esta pantalla: categoría pendiente, género
    // correcto y (si ya hay look) que combinan en color — antes de aplicar
    // los filtros de la izquierda o la búsqueda. p.genders es un array (un
    // artículo puede llevar varios valores a la vez, p. ej. HOMBRE+UNISEX);
    // basta con que UNO de ellos encaje. Sin ningún género reconocido
    // (array vacío, frecuente en calzado/complementos) se deja pasar: no
    // cuenta como "unisex" en otros sitios, pero tampoco se oculta solo por
    // no tener el campo relleno.
    var pool = PRODUCTS.filter(function (p) {
      if (!remainingSet[p.category_group]) return false;
      var genderOk = !allowedGenders || p.genders.length === 0 || p.genders.some(function (g) { return allowedGenders[g]; });
      var matchesLook = !hasItems || colorSuggestScore(p, compatibleTokens) > 0;
      return genderOk && matchesLook;
    });

    function searchOk(p) {
      if (!guiaQuery) return true;
      return p.title.toLowerCase().indexOf(guiaQuery) !== -1 ||
        p.category.toLowerCase().indexOf(guiaQuery) !== -1 ||
        p.color.toLowerCase().indexOf(guiaQuery) !== -1;
    }
    function colorOk(p) { return setSize(guiaFilters.colors) === 0 || setHas(guiaFilters.colors, p.color_family); }
    function activityOk(p) { return setSize(guiaFilters.activities) === 0 || (p.activities || []).some(function (a) { return setHas(guiaFilters.activities, a); }); }

    // ---- rail lateral: Color / Actividad, con recuentos cruzados (el
    // contador de cada chip ignora su propio filtro) y plegables (clases
    // .ctl-rail-section-toggle/.ctl-collapsed; el toggle se gestiona con
    // guiaColorExpanded/guiaActivityExpanded + delegación en
    // guiaRailScrollEl, porque este rail se regenera entero en cada render). ----
    var railHtml = "";
    var colorCounts = {};
    pool.filter(function (p) { return searchOk(p) && activityOk(p); }).forEach(function (p) { colorCounts[p.color_family] = (colorCounts[p.color_family] || 0) + 1; });
    // Más artículos primero; a igualdad, el orden de siempre (alfabético).
    var colorNames = FAMILY_ORDER.filter(function (f) { return colorCounts[f]; })
      .sort(function (a, b) {
        return (colorCounts[b] - colorCounts[a]) || (FAMILY_ORDER.indexOf(a) - FAMILY_ORDER.indexOf(b));
      });
    if (colorNames.length > 0) {
      railHtml +=
        '<button type="button" class="ctl-rail-section-toggle ctl-rail-title" id="ctl-guia-color-toggle" aria-expanded="' + guiaColorExpanded + '" aria-controls="ctl-guia-color-filters">' +
          '<span class="ctl-eyebrow">Color</span>' +
          '<svg class="ctl-rail-chevron" viewBox="0 0 24 24"><use href="#ctl-icon-chevron"></use></svg>' +
        '</button>' +
        '<ul class="ctl-swatch-list' + (guiaColorExpanded ? '' : ' ctl-collapsed') + '" id="ctl-guia-color-filters">';
      colorNames.forEach(function (name) {
        var active = setHas(guiaFilters.colors, name);
        railHtml +=
          '<li><button type="button" class="ctl-swatch" aria-pressed="' + active + '" data-color="' + escapeHtml(name) + '">' +
            '<span class="ctl-swatch-dot" style="' + familyStyle(name) + '"></span>' +
            '<span class="ctl-swatch-label">' + escapeHtml(capitalize(name)) + '</span>' +
            '<span class="ctl-swatch-count">' + colorCounts[name] + '</span>' +
          '</button></li>';
      });
      railHtml += '</ul>';
    }
    var activityCounts = {};
    pool.filter(function (p) { return searchOk(p) && colorOk(p); }).forEach(function (p) { (p.activities || []).forEach(function (a) { activityCounts[a] = (activityCounts[a] || 0) + 1; }); });
    var activityNames = Object.keys(activityCounts).sort(function (a, b) {
      return (activityCounts[b] - activityCounts[a]) || a.localeCompare(b);
    });
    if (activityNames.length > 0) {
      railHtml +=
        '<button type="button" class="ctl-rail-section-toggle ctl-rail-title ctl-rail-title-spaced" id="ctl-guia-activity-toggle" aria-expanded="' + guiaActivityExpanded + '" aria-controls="ctl-guia-activity-filters">' +
          '<span class="ctl-eyebrow">Actividad</span>' +
          '<svg class="ctl-rail-chevron" viewBox="0 0 24 24"><use href="#ctl-icon-chevron"></use></svg>' +
        '</button>' +
        '<ul class="ctl-chip-list' + (guiaActivityExpanded ? '' : ' ctl-collapsed') + '" id="ctl-guia-activity-filters">';
      activityNames.forEach(function (a) {
        var active = setHas(guiaFilters.activities, a);
        railHtml += '<li><button type="button" class="ctl-chip" aria-pressed="' + active + '" data-activity="' + escapeHtml(a) + '">' + escapeHtml(capitalize(a)) + ' <span class="ctl-chip-count">' + activityCounts[a] + '</span></button></li>';
      });
      railHtml += '</ul>';
    }
    if (setSize(guiaFilters.colors) > 0 || setSize(guiaFilters.activities) > 0) {
      railHtml += '<button type="button" class="ctl-clear-filter ctl-visible" id="ctl-guia-clear-filter">Limpiar filtros</button>';
    }
    // El rail de la guía se reconstruye entero (listas nuevas con los mismos
    // ids): se guarda y se restaura la posición de cada carrusel (y el scroll
    // vertical del rail en escritorio) para que marcar varios filtros
    // seguidos no devuelva la lista al principio.
    if (guiaRailScrollEl) {
      var oldColorList = $("#ctl-guia-color-filters");
      var oldActivityList = $("#ctl-guia-activity-filters");
      var keepColorLeft = oldColorList ? oldColorList.scrollLeft : 0;
      var keepActivityLeft = oldActivityList ? oldActivityList.scrollLeft : 0;
      var keepRailTop = guiaRailScrollEl.scrollTop;
      guiaRailScrollEl.innerHTML = railHtml;
      var newColorList = $("#ctl-guia-color-filters");
      var newActivityList = $("#ctl-guia-activity-filters");
      if (newColorList) newColorList.scrollLeft = keepColorLeft;
      if (newActivityList) newActivityList.scrollLeft = keepActivityLeft;
      guiaRailScrollEl.scrollTop = keepRailTop;
    }

    // ---- secciones: una por categoría pendiente, en carrusel horizontal ----
    function sectionItems(slot) {
      return pool.filter(function (p) { return p.category_group === slot && searchOk(p) && colorOk(p) && activityOk(p); })
        .sort(function (a, b) {
          if (hasItems) {
            var scoreA = colorSuggestScore(a, compatibleTokens);
            var scoreB = colorSuggestScore(b, compatibleTokens);
            if (scoreA !== scoreB) return scoreB - scoreA;
          }
          var hueDiff = estimateHue(a.color) - estimateHue(b.color);
          if (hueDiff !== 0) return hueDiff;
          return a.title.localeCompare(b.title);
        });
    }

    var sections = remainingGuiaSlots()
      .map(function (slot) { return { key: slot, items: sectionItems(slot) }; })
      .filter(function (section) { return section.items.length > 0; });

    // #ctl-guia-step (intro/pregunta) y #ctl-guia-sections (carrusel) se
    // limpian por separado — el buscador vive ENTRE los dos como hermano
    // estático (ver template) y nunca se toca, así no pierde el foco.
    guiaStepEl.innerHTML = "";
    if (guiaSectionsEl) guiaSectionsEl.innerHTML = "";

    if (sections.length === 0) {
      // pool.length > 0 significa que hay piezas candidatas pero el filtro
      // de color/actividad o la búsqueda las está ocultando todas — mensaje
      // distinto al de "look completo" para no confundir.
      var hiddenByFilter = pool.length > 0;
      var complete = document.createElement("div");
      complete.className = "ctl-guia-complete";
      complete.innerHTML =
        '<div class="ctl-eyebrow">Guía de looks</div>' +
        '<h2 class="ctl-guia-question">' + (hiddenByFilter ? "Nada coincide con el filtro" : (hasItems ? "¡Tu look está completo!" : "No hay artículos disponibles")) + '</h2>' +
        (hiddenByFilter
          ? '<p class="ctl-guia-subtitle">Prueba a cambiar la búsqueda o quitar algún filtro.</p>'
          : (hasItems
            ? '<p class="ctl-guia-subtitle">Ponle nombre y guárdalo desde el panel "Tu look".</p>'
            : '<p class="ctl-guia-subtitle">No hay categorías disponibles en el catálogo ahora mismo.</p>'));
      guiaStepEl.appendChild(complete);
      return;
    }

    var intro = document.createElement("div");
    intro.className = "ctl-guia-intro";
    intro.innerHTML =
      '<button type="button" class="ctl-guia-back" id="ctl-guia-change-gender">‹ Cambiar género</button>' +
      '<div class="ctl-eyebrow">Guía de looks</div>' +
      '<h2 class="ctl-guia-question">Elige tus piezas</h2>' +
      '<p class="ctl-guia-subtitle">' +
      (hasItems
        ? "Solo se muestran las piezas que combinan con tu look — al elegir una, esa categoría desaparece y el resto se actualiza."
        : "Elige una pieza de cada categoría para ir montando el look.") +
      '</p>';
    guiaStepEl.appendChild(intro);

    if (!guiaSectionsEl) return;
    sections.forEach(function (section) {
      var block = document.createElement("div");
      block.className = "ctl-guia-section";

      var head = document.createElement("div");
      head.className = "ctl-guia-section-head";
      head.innerHTML =
        '<h3 class="ctl-guia-section-title">' + escapeHtml(CATEGORY_GROUP_LABELS[section.key] || section.key) + '</h3>' +
        '<span class="ctl-guia-section-count">' + section.items.length + (section.items.length === 1 ? " artículo" : " artículos") + '</span>';

      var row = document.createElement("div");
      row.className = "ctl-guia-section-row";
      section.items.forEach(function (p) { row.appendChild(buildCardButton(p)); });

      block.appendChild(head);
      block.appendChild(row);
      guiaSectionsEl.appendChild(block);
    });
  }

  if (guiaStepEl) {
    guiaStepEl.addEventListener("click", function (e) {
      var genderCard = e.target.closest(".ctl-guia-gender-card");
      if (genderCard) {
        guiaSelectedGender = genderCard.dataset.gender;
        guiaFilters = { colors: {}, activities: {} };
        guiaQuery = "";
        if (guiaSearchInput) guiaSearchInput.value = "";
        renderGuia();
        return;
      }
      if (e.target.closest("#ctl-guia-change-gender")) {
        guiaSelectedGender = null;
        guiaFilters = { colors: {}, activities: {} };
        guiaQuery = "";
        if (guiaSearchInput) guiaSearchInput.value = "";
        renderGuia();
        return;
      }
    });
  }

  // Las cards viven en #ctl-guia-sections (contenedor aparte de
  // #ctl-guia-step, ver comentario en el template), así que su click de
  // "añadir/quitar del look" se delega aquí.
  if (guiaSectionsEl) {
    guiaSectionsEl.addEventListener("click", function (e) {
      var card = e.target.closest(".ctl-card");
      if (card) toggleLookItem(card.dataset.id);
    });
  }

  if (guiaRailScrollEl) {
    guiaRailScrollEl.addEventListener("click", function (e) {
      if (e.target.closest("#ctl-guia-clear-filter")) {
        guiaFilters = { colors: {}, activities: {} };
        renderGuiaAllCategories();
        return;
      }
      var colorToggle = e.target.closest("#ctl-guia-color-toggle");
      if (colorToggle) {
        guiaColorExpanded = colorToggle.getAttribute("aria-expanded") !== "true";
        colorToggle.setAttribute("aria-expanded", String(guiaColorExpanded));
        var colorFiltersList = $("#ctl-guia-color-filters");
        if (colorFiltersList) colorFiltersList.classList.toggle("ctl-collapsed", !guiaColorExpanded);
        try { localStorage.setItem("ctl_guia_color_filter_expanded_v1", guiaColorExpanded ? "1" : "0"); } catch (err) { /* localStorage no disponible */ }
        return;
      }
      var activityToggle = e.target.closest("#ctl-guia-activity-toggle");
      if (activityToggle) {
        guiaActivityExpanded = activityToggle.getAttribute("aria-expanded") !== "true";
        activityToggle.setAttribute("aria-expanded", String(guiaActivityExpanded));
        var activityFiltersList = $("#ctl-guia-activity-filters");
        if (activityFiltersList) activityFiltersList.classList.toggle("ctl-collapsed", !guiaActivityExpanded);
        try { localStorage.setItem("ctl_guia_activity_filter_expanded_v1", guiaActivityExpanded ? "1" : "0"); } catch (err) { /* localStorage no disponible */ }
        return;
      }
      var colorChip = e.target.closest("[data-color]");
      if (colorChip) {
        var color = colorChip.dataset.color;
        if (setHas(guiaFilters.colors, color)) delete guiaFilters.colors[color];
        else guiaFilters.colors[color] = true;
        renderGuiaAllCategories();
        return;
      }
      var activityChip = e.target.closest("[data-activity]");
      if (activityChip) {
        var activity = activityChip.dataset.activity;
        if (setHas(guiaFilters.activities, activity)) delete guiaFilters.activities[activity];
        else guiaFilters.activities[activity] = true;
        renderGuiaAllCategories();
      }
    });
  }

  if (guiaSearchInput) {
    guiaSearchInput.addEventListener("input", function (e) {
      guiaQuery = e.target.value.trim().toLowerCase();
      renderGuiaAllCategories();
    });
  }

  function renderAddModalGrid() {
    var query = addModalSearch.value.trim().toLowerCase();
    addModalGrid.innerHTML = "";

    if (query) {
      addModalGrid.classList.remove("ctl-sectioned");
      var items = PRODUCTS.filter(function (p) {
        return p.title.toLowerCase().indexOf(query) !== -1 ||
          p.category.toLowerCase().indexOf(query) !== -1 ||
          p.color.toLowerCase().indexOf(query) !== -1;
      });
      addModalSubtitle.textContent = items.length + " resultado" + (items.length === 1 ? "" : "s") + ' para "' + query + '"';
      if (items.length === 0) {
        addModalGrid.innerHTML = '<div class="ctl-add-modal-empty">No hay artículos que coincidan.</div>';
        return;
      }
      items.slice(0, 60).forEach(function (p) { addModalGrid.appendChild(buildCardButton(p)); });
      return;
    }

    addModalGrid.classList.add("ctl-sectioned");

    if (setSize(state.lookItems) === 0) {
      addModalSubtitle.textContent = "Añade una pieza o busca cualquier artículo del catálogo";
      addModalGrid.innerHTML = '<div class="ctl-add-modal-empty">Añade una pieza desde la mesa para ver sugerencias por secciones.</div>';
      return;
    }

    var sections = suggestionSections();
    if (sections.length === 0) {
      addModalSubtitle.textContent = "Sin sugerencias de color todavía — prueba a buscar";
      addModalGrid.innerHTML = '<div class="ctl-add-modal-empty">Nada que sugerir por ahora.</div>';
      return;
    }

    addModalSubtitle.textContent = "Sugerencias por color y género, una sección por tipo de prenda";
    sections.forEach(function (section) {
      var block = document.createElement("div");
      block.className = "ctl-modal-section";

      var title = document.createElement("div");
      title.className = "ctl-eyebrow ctl-modal-section-title";
      title.textContent = section.label;

      var row = document.createElement("div");
      row.className = "ctl-modal-section-row";
      section.items.forEach(function (p) { row.appendChild(buildCardButton(p)); });

      block.appendChild(title);
      block.appendChild(row);
      addModalGrid.appendChild(block);
    });
  }

  function updateSaveState() {
    var hasName = saveNameInput.value.trim().length > 0;
    saveBtn.disabled = !(hasName && setSize(state.lookItems) > 0);
  }

  function renderAll() {
    renderBoard();
    updateSaveState();
    renderGuia();
  }

  function formatDate(iso) {
    return new Date(iso).toLocaleDateString("es-ES", { day: "2-digit", month: "short" }).replace(".", "");
  }

  function renderArmario() {
    if (PRODUCTS.length === 0) ensureProductsLoaded();
    $("#ctl-armario-count").textContent = savedLooks.length + " " + (savedLooks.length === 1 ? "look guardado" : "looks guardados");
    armarioGrid.innerHTML = "";
    if (savedLooks.length === 0) {
      var empty = document.createElement("div");
      empty.className = "ctl-armario-empty";
      empty.innerHTML = 'Aún no has guardado ningún look.<div class="ctl-armario-empty-links"><button class="ctl-armario-empty-link" id="ctl-go-guia">Ir a la guía de looks</button></div>';
      armarioGrid.appendChild(empty);
      return;
    }
    savedLooks.forEach(function (look) {
      var pieces = look.itemIds.map(function (id) { return PRODUCTS.filter(function (p) { return p.id === id; })[0]; }).filter(Boolean);
      var row = document.createElement("div");
      row.className = "ctl-look-row";
      row.innerHTML =
        '<div class="ctl-look-row-head">' +
        '<div class="ctl-look-row-title"><div>' +
        '<input class="ctl-look-row-name-input" data-id="' + escapeHtml(look.id) + '" value="' + escapeHtml(look.name) + '" maxlength="60" aria-label="Nombre del look">' +
        '<div class="ctl-look-row-meta">' + pieces.length + ' ' + (pieces.length === 1 ? "pieza" : "piezas") + ' &middot; ' + formatDate(look.createdAt) + '</div>' +
        '</div></div>' +
        '<div class="ctl-look-row-right"><div class="ctl-look-row-actions">' +
        '<button class="ctl-look-row-btn" data-action="add-to-cart" data-id="' + escapeHtml(look.id) + '">Añadir al carrito</button>' +
        '<button class="ctl-look-row-btn ctl-ghost" data-action="edit" data-id="' + escapeHtml(look.id) + '">Editar</button>' +
        '<button class="ctl-look-row-delete" data-action="delete" data-id="' + escapeHtml(look.id) + '" aria-label="Eliminar ' + escapeHtml(look.name) + '">' + iconSvg("trash") + '</button>' +
        '</div></div>' +
        '</div>' +
        '<div class="ctl-look-row-strip-wrap"><div class="ctl-look-row-strip">' +
        pieces.map(function (p) { return '<span class="ctl-look-tile" style="--ctl-tile-color:' + colorFor(p.color) + '" title="' + escapeHtml(p.title) + '">' + productImage(p) + '</span>'; }).join("") +
        '</div><button type="button" class="ctl-look-row-more" aria-label="Ver más piezas">' + iconSvg("chevron") + '</button></div>';
      armarioGrid.appendChild(row);
    });
  }

  function switchView(view) {
    currentView = view;
    $("#ctl-view-guia").classList.toggle("ctl-is-hidden", view !== "guia");
    $("#ctl-view-armario").classList.toggle("ctl-is-hidden", view !== "armario");
    tabs.forEach(function (t) { t.setAttribute("aria-pressed", String(t.dataset.view === view)); });

    if (view === "armario") renderArmario();
    else renderGuia();
  }

  var toastTimer;
  function showToast(text) {
    toastText.textContent = text;
    toast.classList.add("ctl-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("ctl-visible"); }, 3200);
  }

  boardList.addEventListener("click", function (e) {
    if (e.target.closest("#ctl-open-add-modal")) { openAddModal(); return; }
    var btn = e.target.closest(".ctl-board-item-remove");
    if (!btn) return;
    delete state.lookItems[btn.dataset.id];
    guiaFilters = { colors: {}, activities: {} };
    guiaQuery = "";
    if (guiaSearchInput) guiaSearchInput.value = "";
    refreshAfterLookChange();
  });

  if (boardClearBtn) {
    boardClearBtn.addEventListener("click", function () {
      if (setSize(state.lookItems) === 0) return;
      state.lookItems = {};
      guiaFilters = { colors: {}, activities: {} };
      guiaQuery = "";
      if (guiaSearchInput) guiaSearchInput.value = "";
      saveNameInput.value = "";
      refreshAfterLookChange();
      showToast("Look vaciado");
    });
  }

  saveNameInput.addEventListener("input", updateSaveState);

  saveBtn.addEventListener("click", function () {
    if (saveBtn.disabled) return;
    var name = saveNameInput.value.trim();
    var items = Object.keys(state.lookItems);
    var now = new Date().toISOString();
    savedLooks.unshift({ id: genId(), name: name, itemIds: items, createdAt: now, updatedAt: now });
    persistLooks();
    var savedPieces = PRODUCTS.filter(function (p) { return setHas(state.lookItems, p.id); });
    track("look_saved", {
      pieces: savedPieces.length,
      value: Math.round(savedPieces.reduce(function (sum, p) { return sum + (p.price || 0); }, 0) * 100) / 100,
      source: "guia",
      gender: guiaSelectedGender,
      neutrals: neutralsOn
    });
    state.lookItems = {};
    saveNameInput.value = "";
    renderAll();
    showToast('"' + name + '" guardado en Mis looks');
    switchView("armario");
  });

  tabs.forEach(function (t) { t.addEventListener("click", function () { switchView(t.dataset.view); }); });

  // ---------- mostrar/ocultar colores neutros en las sugerencias ----------
  // Hay dos botones (panel "Tu look" y cabecera del popup "Añadir pieza"),
  // así que se puede activar/desactivar sin cerrar el popup; se mantienen
  // sincronizados y el popup se vuelve a pintar en refreshAfterLookChange().
  var neutralToggleBtns = document.querySelectorAll(".ctl-neutral-toggle");
  function syncNeutralToggle() {
    neutralToggleBtns.forEach(function (btn) {
      btn.textContent = neutralsOn ? "Ocultar neutros" : "Mostrar neutros";
      btn.setAttribute("aria-pressed", String(neutralsOn));
    });
  }
  neutralToggleBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      neutralsOn = !neutralsOn;
      try { localStorage.setItem(NEUTRALS_STORAGE_KEY, neutralsOn ? "1" : "0"); } catch (e) { /* localStorage no disponible */ }
      syncNeutralToggle();
      refreshAfterLookChange();
    });
  });
  syncNeutralToggle();

  // Botón de ocultar/mostrar filtros del rail de la "Guía de looks"
  // (#ctl-guia-rail). En escritorio la preferencia se recuerda en
  // localStorage; en móvil (mismo corte que el layout apilado del CSS, 900px)
  // los filtros arrancan SIEMPRE ocultos — ocupan media pantalla antes de ver
  // ningún artículo — y lo que se haga con el botón no se guarda.
  var guiaGrid = document.querySelector(".ctl-guia-grid");
  var guiaFilterToggleBtn = $("#ctl-guia-filter-toggle");
  var GUIA_RAIL_HIDDEN_KEY = "ctl_guia_rail_hidden_v1";
  function isMobileLayout() { return window.innerWidth <= 900; }
  function setGuiaRailHidden(hidden) {
    if (!guiaGrid || !guiaFilterToggleBtn) return;
    guiaGrid.classList.toggle("ctl-rail-hidden", hidden);
    guiaFilterToggleBtn.textContent = hidden ? "Mostrar filtros" : "Ocultar filtros";
    guiaFilterToggleBtn.setAttribute("aria-pressed", String(!hidden));
    if (isMobileLayout()) return;
    try { localStorage.setItem(GUIA_RAIL_HIDDEN_KEY, hidden ? "1" : "0"); } catch (e) { /* localStorage no disponible */ }
  }
  if (guiaFilterToggleBtn) {
    guiaFilterToggleBtn.addEventListener("click", function () {
      setGuiaRailHidden(!guiaGrid.classList.contains("ctl-rail-hidden"));
    });
  }
  (function initGuiaRailState() {
    var hidden = isMobileLayout();
    if (!hidden) {
      try { hidden = localStorage.getItem(GUIA_RAIL_HIDDEN_KEY) === "1"; } catch (e) { /* localStorage no disponible */ }
    }
    setGuiaRailHidden(hidden);
  })();

  // ---------- popup "Añadir look al carrito" (con selector de talla) ----------
  // Cada pieza guarda ya todas sus variantes disponibles (ver
  // fetchAllProducts → variants), así que se ofrece un <select> por pieza
  // con solo las tallas realmente en stock; si no queda ninguna, se marca
  // "Agotado" y esa pieza simplemente no se manda. El envío es una única
  // llamada a /cart/add.js con todas las tallas elegidas (igual que hace la
  // sección de referencia "Izas · Looks"), y se avisa al tema con los mismos
  // eventos que ya usa theme-snippet/vestidor-cart-suggestions.liquid para
  // refrescar el contador/drawer del carrito.
  var cartModal = $("#ctl-cart-modal");
  var cartModalList = $("#ctl-cart-modal-list");
  var cartModalSubtitle = $("#ctl-cart-modal-subtitle");
  var cartModalSubmit = $("#ctl-cart-modal-submit");
  var cartModalCloseBtn = $("#ctl-cart-modal-close");
  var cartModalTrigger = null;
  var cartModalLook = null;

  // Una talla agotada se puede seleccionar (para poder pedir el aviso de
  // stock) pero no cuenta para "Añadir al carrito".
  function selectedIsSoldOut(sel) {
    var opt = sel.options[sel.selectedIndex];
    return !!opt && opt.dataset.soldout === "1";
  }

  function updateCartModalSubmitState() {
    var count = 0;
    cartModalList.querySelectorAll(".ctl-cart-item-select").forEach(function (sel) { if (sel.value && !selectedIsSoldOut(sel)) count++; });
    cartModalSubmit.disabled = count === 0;
    cartModalSubmit.textContent = count > 0 ? "Añadir al carrito (" + count + ")" : "Selecciona tallas";
  }

  function openCartModal(look) {
    cartModalLook = look;
    cartModalTrigger = document.activeElement;
    var pieces = look.itemIds.map(function (id) { return PRODUCTS.filter(function (p) { return p.id === id; })[0]; }).filter(Boolean);
    cartModalSubtitle.textContent = pieces.length + " " + (pieces.length === 1 ? "artículo" : "artículos") + ' en "' + look.name + '"';
    cartModalList.innerHTML = "";

    if (pieces.length === 0) {
      cartModalList.innerHTML = '<div class="ctl-add-modal-empty">Este look no tiene piezas disponibles.</div>';
    } else {
      pieces.forEach(function (p) {
        // Todas las tallas del color en su orden; las agotadas se marcan y
        // al elegirlas sale "Avísame cuando esté disponible" (ver más abajo).
        var variants = p.all_variants || (p.variants || []).map(function (v) { return { id: v.id, size: v.size, available: true }; });
        var row = document.createElement("div");
        row.className = "ctl-cart-item";
        var optionsHtml = variants.map(function (v) {
          return '<option value="' + escapeHtml(v.id) + '"' + (v.available ? '' : ' data-soldout="1"') + '>' +
            escapeHtml(v.size) + (v.available ? '' : ' — agotada') + '</option>';
        }).join("");
        row.innerHTML =
          '<span class="ctl-cart-item-icon">' + productImage(p) + '</span>' +
          '<div class="ctl-cart-item-info">' +
            '<span class="ctl-cart-item-name">' + escapeHtml(p.title) + '</span>' +
            '<span class="ctl-cart-item-price">' + formatMoney(p.price, p.currency) + '</span>' +
            (variants.length > 0
              ? '<select class="ctl-cart-item-select" data-product-id="' + escapeHtml(p.id) + '"><option value="" disabled selected>Talla…</option>' + optionsHtml + '</select>' +
                '<button type="button" class="ctl-notify-btn" hidden>Avísame cuando esté disponible</button>'
              : '<span class="ctl-cart-item-soldout">Agotado</span>') +
          '</div>';
        cartModalList.appendChild(row);
      });
    }

    updateCartModalSubmitState();
    cartModal.classList.add("ctl-open");
  }

  function closeCartModal() {
    cartModal.classList.remove("ctl-open");
    if (cartModalTrigger && document.body.contains(cartModalTrigger)) cartModalTrigger.focus();
    cartModalTrigger = null;
    cartModalLook = null;
  }

  cartModalCloseBtn.addEventListener("click", closeCartModal);
  cartModal.addEventListener("click", function (e) { if (e.target === cartModal) closeCartModal(); });
  cartModalList.addEventListener("change", function (e) {
    if (!e.target.classList.contains("ctl-cart-item-select")) return;
    var notifyBtn = e.target.parentElement.querySelector(".ctl-notify-btn");
    if (notifyBtn) notifyBtn.hidden = !selectedIsSoldOut(e.target);
    updateCartModalSubmitState();
  });

  // ---------- popup "Avísame cuando esté disponible" ----------
  // Mismo servicio y mismos campos que el modal de la PDP
  // (ff-main-product.liquid → "MODAL DE BACK IN STOCK CUSTOM").
  var notifyModal = $("#ctl-notify-modal");
  var notifyForm = $("#ctl-notify-form");
  var notifyEmail = $("#ctl-notify-email");
  var notifySubmit = $("#ctl-notify-submit");
  var notifySuccess = $("#ctl-notify-success");
  var notifyImage = $("#ctl-notify-image");
  var notifyProduct = $("#ctl-notify-product");
  var notifyVariantLabel = $("#ctl-notify-variant");
  var notifyCloseBtn = $("#ctl-notify-close");
  var notifyTarget = null;
  var notifyTrigger = null;
  var notifyCloseTimer;

  function openNotifyModal(p, variantId, size) {
    var variantTitle = size === "Talla única" ? p.color : p.color + " / " + size;
    notifyTarget = { variant_id: String(variantId), product_title: p.title, image_url: p.image_url || "", variant_title: variantTitle };
    notifyTrigger = document.activeElement;
    notifyProduct.textContent = p.title;
    notifyVariantLabel.textContent = variantTitle;
    notifyImage.src = p.image_url || "";
    notifyForm.hidden = false;
    notifySuccess.hidden = true;
    notifySubmit.disabled = false;
    notifySubmit.textContent = "Enviar aviso";
    notifyModal.classList.add("ctl-open");
  }

  function closeNotifyModal() {
    clearTimeout(notifyCloseTimer);
    notifyModal.classList.remove("ctl-open");
    notifyTarget = null;
    if (notifyTrigger && document.body.contains(notifyTrigger)) notifyTrigger.focus();
    notifyTrigger = null;
  }

  cartModalList.addEventListener("click", function (e) {
    var btn = e.target.closest(".ctl-notify-btn");
    if (!btn) return;
    var sel = btn.parentElement.querySelector(".ctl-cart-item-select");
    if (!sel || !sel.value || !selectedIsSoldOut(sel)) return;
    var p = PRODUCTS.filter(function (x) { return x.id === sel.dataset.productId; })[0];
    if (!p) return;
    var variant = (p.all_variants || []).filter(function (v) { return String(v.id) === sel.value; })[0];
    openNotifyModal(p, sel.value, variant ? variant.size : "");
  });

  notifyCloseBtn.addEventListener("click", closeNotifyModal);
  notifyModal.addEventListener("click", function (e) { if (e.target === notifyModal) closeNotifyModal(); });

  notifyForm.addEventListener("submit", function (e) {
    e.preventDefault();
    if (!notifyTarget) return;
    notifySubmit.disabled = true;
    notifySubmit.textContent = "Enviando…";
    var payload = {
      email: notifyEmail.value.trim(),
      variant_id: notifyTarget.variant_id,
      product_title: notifyTarget.product_title,
      image_url: notifyTarget.image_url,
      variant_title: notifyTarget.variant_title
    };
    fetch(BACK_IN_STOCK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (res) { return res.json(); }).then(function (data) {
      if (!data.success) throw new Error("respuesta no válida");
      notifyForm.hidden = true;
      notifySuccess.hidden = false;
      notifyEmail.value = "";
      notifyCloseTimer = setTimeout(closeNotifyModal, 2500);
    }).catch(function () {
      showToast("No se pudo registrar el aviso, inténtalo de nuevo.");
      notifySubmit.disabled = false;
      notifySubmit.textContent = "Enviar aviso";
    });
  });

  cartModalSubmit.addEventListener("click", function () {
    if (cartModalSubmit.disabled || !cartModalLook) return;
    var items = [];
    // _Origen (con guion bajo delante): las properties con "_" al principio
    // se ocultan en el carrito/checkout de cara al cliente, pero se quedan
    // pegadas a la línea del pedido y se ven en el admin de Shopify — así
    // se puede filtrar/exportar más tarde qué pedidos incluyen artículos
    // añadidos desde "Crea tu look" (y desde qué look guardado, en concreto).
    cartModalList.querySelectorAll(".ctl-cart-item-select").forEach(function (sel) {
      if (sel.value && !selectedIsSoldOut(sel)) {
        items.push({
          id: parseInt(sel.value, 10),
          quantity: 1,
          properties: { "_Origen": "Crea tu look", "_Look": cartModalLook.name }
        });
      }
    });
    if (items.length === 0) return;

    var look = cartModalLook;
    var originalLabel = cartModalSubmit.textContent;
    cartModalSubmit.disabled = true;
    cartModalSubmit.textContent = "Añadiendo…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || "No se pudo añadir al carrito"); });
      return res.json();
    }).then(function () {
      track("look_added_to_cart", { items: items.length, look_pieces: look.itemIds.length });
      showToast('"' + look.name + '" añadido al carrito (' + items.length + (items.length === 1 ? " artículo" : " artículos") + ')');
      document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", { bubbles: true }));
      closeCartModal();
    }).catch(function (err) {
      showToast("No se pudo añadir al carrito: " + err.message);
      cartModalSubmit.disabled = false;
      cartModalSubmit.textContent = originalLabel;
    });
  });

  // Género con el que reabrir la guía al editar un look guardado: infantil si
  // alguna pieza lo es; hombre/mujer si todas las piezas con género van de un
  // solo lado; unisex en el resto de casos (el usuario puede cambiarlo con
  // "‹ Cambiar género").
  function inferGenderFromLook(look) {
    var genders = {};
    look.itemIds.forEach(function (id) {
      var p = PRODUCTS.filter(function (x) { return x.id === id; })[0];
      if (p) (p.genders || []).forEach(function (g) { genders[g] = true; });
    });
    if (genders.infantil) return "infantil";
    if (genders.hombre && !genders.mujer) return "hombre";
    if (genders.mujer && !genders.hombre) return "mujer";
    return "unisex";
  }

  armarioGrid.addEventListener("click", function (e) {
    if (e.target.closest("#ctl-go-guia")) { switchView("guia"); return; }

    var moreBtn = e.target.closest(".ctl-look-row-more");
    if (moreBtn) {
      var strip = moreBtn.parentElement.querySelector(".ctl-look-row-strip");
      if (strip) strip.scrollBy({ left: strip.clientWidth * 0.85, behavior: reducedMotion ? "auto" : "smooth" });
      return;
    }

    var btn = e.target.closest("[data-action]");
    if (!btn) return;
    var id = btn.dataset.id;
    var look = savedLooks.filter(function (l) { return l.id === id; })[0];
    if (!look) return;

    if (btn.dataset.action === "add-to-cart") {
      openCartModal(look);
    } else if (btn.dataset.action === "edit") {
      savedLooks = savedLooks.filter(function (l) { return l.id !== id; });
      persistLooks();
      state.lookItems = {};
      look.itemIds.forEach(function (itemId) { state.lookItems[itemId] = true; });
      saveNameInput.value = look.name;
      // La guía necesita un género elegido para salir del primer paso: se
      // deduce de las piezas del look que se edita.
      guiaSelectedGender = inferGenderFromLook(look);
      guiaFilters = { colors: {}, activities: {} };
      guiaQuery = "";
      if (guiaSearchInput) guiaSearchInput.value = "";
      renderAll();
      switchView("guia");
      showToast('Editando "' + look.name + '" — vuelve a guardarlo cuando termines');
    } else if (btn.dataset.action === "delete") {
      openDeleteModal(look);
    }
  });

  var deleteModal = $("#ctl-delete-modal");
  var modalLookName = $("#ctl-modal-look-name");
  var modalCancelBtn = $("#ctl-modal-cancel");
  var modalConfirmBtn = $("#ctl-modal-confirm");
  var modalTrigger = null;

  function openDeleteModal(look) {
    pendingDeleteId = look.id;
    modalTrigger = document.activeElement;
    modalLookName.textContent = '"' + look.name + '"';
    deleteModal.classList.add("ctl-open");
    modalConfirmBtn.focus();
  }
  function closeDeleteModal() {
    deleteModal.classList.remove("ctl-open");
    pendingDeleteId = null;
    if (modalTrigger && document.body.contains(modalTrigger)) modalTrigger.focus();
    modalTrigger = null;
  }
  modalCancelBtn.addEventListener("click", closeDeleteModal);
  modalConfirmBtn.addEventListener("click", function () {
    var look = savedLooks.filter(function (l) { return l.id === pendingDeleteId; })[0];
    var id = pendingDeleteId;
    closeDeleteModal();
    if (!look) return;
    savedLooks = savedLooks.filter(function (l) { return l.id !== id; });
    persistLooks();
    track("look_deleted", { look_pieces: look.itemIds.length });
    renderArmario();
    showToast('"' + look.name + '" eliminado de Mis looks');
  });
  deleteModal.addEventListener("click", function (e) { if (e.target === deleteModal) closeDeleteModal(); });

  var addModal = $("#ctl-add-modal");
  var addModalSearch = $("#ctl-add-modal-search");
  var addModalGrid = $("#ctl-add-modal-grid");
  var addModalSubtitle = $("#ctl-add-modal-subtitle");
  var addModalCloseBtn = $("#ctl-add-modal-close");
  var addModalTrigger = null;

  function openAddModal() {
    addModalTrigger = document.activeElement;
    addModalSearch.value = "";
    addModal.classList.add("ctl-open");
    renderAddModalGrid();
  }
  function closeAddModal() {
    addModal.classList.remove("ctl-open");
    if (addModalTrigger && document.body.contains(addModalTrigger)) addModalTrigger.focus();
    addModalTrigger = null;
  }
  addModalCloseBtn.addEventListener("click", closeAddModal);
  addModalSearch.addEventListener("input", renderAddModalGrid);
  addModalGrid.addEventListener("click", function (e) {
    var card = e.target.closest(".ctl-card");
    if (!card) return;
    toggleLookItem(card.dataset.id);
  });
  addModal.addEventListener("click", function (e) { if (e.target === addModal) closeAddModal(); });

  function getFocusable(container) {
    return Array.prototype.slice.call(container.querySelectorAll('button:not(:disabled), input:not(:disabled), [tabindex]:not([tabindex="-1"])'));
  }
  document.addEventListener("keydown", function (e) {
    // notifyModal primero: se abre encima del popup del carrito, así Escape/Tab
    // actúan sobre el de arriba.
    var openModal = [notifyModal, deleteModal, addModal, cartModal].filter(function (m) { return m.classList.contains("ctl-open"); })[0];
    if (!openModal) return;
    if (e.key === "Escape") {
      if (openModal === notifyModal) closeNotifyModal();
      else if (openModal === deleteModal) closeDeleteModal();
      else if (openModal === addModal) closeAddModal();
      else closeCartModal();
      return;
    }
    if (e.key === "Tab") {
      var focusable = getFocusable(openModal);
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  armarioGrid.addEventListener("focusout", function (e) {
    var input = e.target.closest(".ctl-look-row-name-input");
    if (!input) return;
    var look = savedLooks.filter(function (l) { return l.id === input.dataset.id; })[0];
    if (!look) return;
    var newName = input.value.trim();
    if (!newName || newName === look.name) { input.value = look.name; return; }
    look.name = newName;
    look.updatedAt = new Date().toISOString();
    persistLooks();
  });
  armarioGrid.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && e.target.classList.contains("ctl-look-row-name-input")) e.target.blur();
  });

  // ---------- evitar que el header fijo/sticky del tema tape el título ----------
  // No sabemos qué selector usa el header de tu tema, así que en vez de
  // adivinarlo por CSS, medimos en runtime cualquier elemento anclado arriba
  // del viewport con position:fixed/sticky (que no sea nuestro) y empujamos
  // el shell justo debajo de su altura real.
  function isOwnElement(el) {
    if (!el || el.id === "ctl-app") return true;
    if (el.closest && el.closest("#ctl-app")) return true;
    var cls = el.className;
    if (typeof cls === "string" && cls.indexOf("ctl-") !== -1) return true;
    return false;
  }

  // El alto de escritorio (100vh real) se fija aquí directamente con un
  // "height" inline sobre .ctl-shell — se probó a propagarlo por CSS
  // (flexbox encadenado desde <body> a través de los envoltorios del tema)
  // y no fue fiable: depende de que CADA envoltorio intermedio del tema sea
  // realmente flex, y no lo era, así que no limitaba nada y la página
  // volvía a escrolear entera. Un valor inline no depende de cómo esté
  // maquetado el resto del tema.
  function adjustForFixedHeader() {
    var shell = document.querySelector(".ctl-shell");
    if (!shell) return;
    // OJO: nada de resetear marginTop/height a "" antes de medir. Este
    // recálculo se dispara con cualquier cambio de DOM en TODA la página
    // (no solo dentro de la app — banners, widgets de chat, lo que sea), así
    // que pasa muy a menudo; vaciar el height un instante en cada pasada
    // quitaba el límite de alto justo cuando el usuario estaba scrolleando,
    // el navegador recalculaba el scroll de golpe y el contenido "saltaba"
    // hacia arriba. En su lugar se calcula el valor nuevo y solo se toca el
    // estilo si de verdad ha cambiado.
    var maxBottom = 0;
    var all = document.body.querySelectorAll("*");
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (isOwnElement(el)) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position !== "fixed" && cs.position !== "sticky") continue;
      var rect = el.getBoundingClientRect();
      if (rect.height <= 0 || rect.height > window.innerHeight * 0.5) continue;
      if (rect.top > 5) continue;
      if (rect.bottom > maxBottom) maxBottom = rect.bottom;
    }
    var newMarginTop = maxBottom > 0 ? maxBottom + "px" : "";
    if (shell.style.marginTop !== newMarginTop) shell.style.marginTop = newMarginTop;
    // Con marginTop ya aplicado, shell.getBoundingClientRect().top + scrollY
    // da la distancia real desde el principio del documento hasta el shell
    // — cubre un header fijo/sticky (vía el marginTop de arriba) y uno en
    // flujo normal (cualquiera que sea su alto, sin necesidad de medirlo
    // aparte) con el mismo cálculo. Solo en escritorio (>900px, mismo corte
    // que el breakpoint de layout apilado en el CSS); en móvil se deja sin
    // fijar para que la app siga con scroll libre y los paneles apilados.
    if (window.innerWidth > 900) {
      var topOffset = shell.getBoundingClientRect().top + window.scrollY;
      var newHeight = "calc(100vh - " + topOffset + "px)";
      if (shell.style.height !== newHeight) shell.style.height = newHeight;
    } else if (shell.style.height) {
      shell.style.height = "";
    }
  }

  window.addEventListener("load", adjustForFixedHeader);
  document.addEventListener("DOMContentLoaded", adjustForFixedHeader);
  setTimeout(adjustForFixedHeader, 400);

  // En vez de más timeouts a ciegas (que podían medir el hueco justo cuando
  // había una barra de cookies/promo temporal abierta y dejar el margen
  // inflado para siempre), se re-mide cada vez que cambia algo relevante del
  // DOM o del estilo del header (p. ej. al cerrar el aviso de cookies, o
  // cuando un header "sticky on scroll" cambia de clase/alto).
  var headerObserverTimer;
  var headerObserver = new MutationObserver(function (mutations) {
    // Se ignoran los cambios que vienen de DENTRO de la propia app (#ctl-app
    // se re-renderiza constantemente: filtros, cards, el mismo margin-top
    // que esta función acaba de aplicar...). Sin este filtro, cada uno de
    // esos cambios volvía a disparar esta misma función, que a su vez
    // tocaba shell.style.marginTop, lo que generaba otro cambio observado:
    // un bucle infinito de remediciones que iba y venía constantemente en
    // vez de asentarse una sola vez.
    var relevant = mutations.some(function (m) {
      return !(m.target.closest && m.target.closest("#ctl-app"));
    });
    if (!relevant) return;
    clearTimeout(headerObserverTimer);
    headerObserverTimer = setTimeout(adjustForFixedHeader, 200);
  });
  headerObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["style", "class"] });

  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(adjustForFixedHeader, 150);
  });

  // ---------- init ----------
  // Ya no se pide el catálogo aquí: el paso de género (pestaña por defecto)
  // no lo necesita, así que se pide solo cuando hace falta de verdad (ver
  // ensureProductsLoaded, llamado desde renderGuia/renderArmario).
  loadLooks();
  switchView("guia"); // activa aria-pressed y muestra el paso de género al instante
})();
